// AUTOGENERATED FILE
// see insights/generate_metric_types.py

export const LtvTimeKeys = [
  "Alltime",
  "Same Month",
  "One Month",
  "Two Month",
  "Three Month",
  "Four Month",
  "Five Month",
  "Six Month",
  "Seven Month",
  "Eight Month",
  "Nine Month",
  "Ten Month",
  "Eleven Month",
  "Twelve Month",
  "Thirteen Month",
  "Fourteen Month",
  "Fifteen Month",
  "Sixteen Month",
  "Seventeen Month",
  "Eighteen Month",
  "Nineteen Month",
  "Twenty Month",
  "Twenty-One Month",
  "Twenty-Two Month",
  "Twenty-Three Month",
  "Twenty-Four Month",
];
